// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fvb91","colMin":"styles_colMin__2JAvZ"};